export default __webpack_public_path__ + "baa9464cc9df63a36ce84202220e941c.svg";